import cm from 'classnames';

import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { selectFiles } from 'components/app/_mediator/app-files.slice';
import { setFile } from './_mediator/pp.slice';
import styles from './_style.module.scss';

export const PpFiles = () => {
  const { file } = useAppSelector((state) => state.pp);
  const { videos } = useAppSelector(selectFiles);
  const dispatch = useAppDispatch();

  return (
    <div className={styles.Files}>
      {videos.map((el) => (
        <li
          key={el.id}
          className={cm(styles.Files__el, { [styles['Files__el--selected']]: el.id === file })}
          onClick={() => dispatch(setFile(el.id))}
        >
          <h3>{el.id}</h3>
          <h4>{el.fileName}</h4>
        </li>
      ))}
    </div>
  );
};
